import { BooleanInput, DateInput, EditBase, FormDataConsumer, required, SelectInput, TextInput } from "react-admin";
import { approvalStatusChoices } from "../../model/approvalStatusChoices";
import { ExaminationAssignmentReceivedAtInput } from "../../inputs/ExaminationAssignmentExpiresAtInput";
import { ExaminationAssignmentExpiresAtInput } from "../../inputs/ExaminationAssignmentReceivedAtInput";
import { DialogActions, DialogContent } from "@mui/material";
import { Form2 } from "../../misc/Form2";
import { SaveButton2 } from "../../buttons/SaveButton2";
import { date, dateMinYear, dateNotInTheFuture } from "../../utils/validators";
import { ExamEligibilityInfo } from "./ExamEligibilityInfo";

export function StudentAdministrativeOnboardingForm({ onSaved }: { onSaved: () => void }) {
  return (
    <EditBase redirect={false} mutationMode="pessimistic" mutationOptions={{ onSuccess: onSaved }}>
      <Form2 shouldUnregister>
        <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.administrativeOnboardingState?.applicationApproved === "pending") {
                return (
                  <>
                    <BooleanInput label="Erste-Hilfe-Kurs" source="administrativeOnboardingState.firstAidCourseDone" />
                    <BooleanInput label="Sehtest" source="administrativeOnboardingState.eyeTestDone" />
                    <BooleanInput label="Passbild" source="administrativeOnboardingState.photoTaken" />
                    <BooleanInput
                      label="Antrag ausgefüllt"
                      source="administrativeOnboardingState.applicationFilledOut"
                    />
                    <BooleanInput
                      label="Antrag eingereicht"
                      source="administrativeOnboardingState.applicationSubmitted"
                    />
                    <DateInput
                      sx={{ width: "15em" }}
                      size="small"
                      label="Antrag abgegeben am"
                      source="administrativeOnboardingState.applicationSubmittedAt"
                      validate={[date(), dateMinYear(2000), dateNotInTheFuture()]}
                    />
                  </>
                );
              }
            }}
          </FormDataConsumer>
          <TextInput
            defaultValue=""
            sx={{ width: "15em" }}
            label="Antragsnummer"
            source="administrativeOnboardingState.applicationNumber"
            parse={(value) => (value === "" ? "" : value)}
          />
          <SelectInput
            sx={{ width: "15em" }}
            label="Status"
            source="administrativeOnboardingState.applicationApproved"
            choices={approvalStatusChoices}
            validate={required()}
          />
          <FormDataConsumer>
            {({ formData }) => {
              if (formData.administrativeOnboardingState.applicationApproved === "approved") {
                return (
                  <>
                    <ExaminationAssignmentReceivedAtInput />
                    <ExaminationAssignmentExpiresAtInput />
                  </>
                );
              }
            }}
          </FormDataConsumer>
          <ExamEligibilityInfo />
        </DialogContent>
        <DialogActions>
          <SaveButton2 />
        </DialogActions>
      </Form2>
    </EditBase>
  );
}
